import { Component } from "@angular/core";

import { Validacao } from "./validacao";
import { ValidacaoService } from "./validacao.service";
import { Estudo } from "../estudo/estudo";
import { EstudoService } from "../estudo/estudo.service";
import { SituacaoEnum } from "../util/situacao.enum";
import { Router, ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { PagerComponent } from "../paginator/pager.component";
import { GrupoFamiliar } from "../grupo-familiar/grupo-familiar";
import { MatDialog } from "@angular/material";
import { ValidacaoDialog } from "./validacao.dialog";

@Component({
  templateUrl: "./validacao-detail.component.html",
  styles: [".valido { background-color: red; } .invalida { bgcolor: white }  "],
  selector: "validacao-detail"
})
export class ValidacaoDetailComponent {
  public estudo: Estudo;
  public estudoComparacao: Estudo;
  public itemSelecionado: Validacao;
  public atualizarLista: boolean = false;

  // Esses class sao referentes aos CSS de cada aba.
  public class_1: string; //1.Introducao
  public class_2: string; //2.EstudoPreliminar
  public class_3: string; //3.DadosPessoais
  public posicao_atual: number;

  public mostrarPainelEdicao: boolean;
  // controla o loading da pagina
  public isLoading: boolean;
  // controla a variavel do grupo familiar
  public idGrupoFamiliarSelecionado: number;

  // construtor
  constructor(
    private validacaoService: ValidacaoService,
    private estudoService: EstudoService,
    private route: ActivatedRoute,
    public mensagem: MatSnackBar,
    private pagerComponent: PagerComponent,
    public dialog: MatDialog
  ) {}

  // ngOnInit é executado ao entrar na tela
  public ngOnInit() {
    this.posicao_atual = 1;
    this.controlaClasse();
    this.carregaEstudo();
  }

  private carregaEstudo() {
    let id: any = this.route.snapshot.params["id"];
    if (id && id != "new") {
      this.isLoading = true;
      this.estudoService.getId(parseInt(id)).subscribe(
        result => {
          this.estudo = result;
          this.validacaoInicial();
          this.isLoading = false;
        },
        error => this.erro(error)
      );
    }
  }

  private validacaoInicial() {
    if (
      this.estudo.situacao != SituacaoEnum.EmAnalise &&
      this.estudo.situacao != SituacaoEnum.Corrigido
    ) {
      this.mostrarPainelEdicao = false;
    } else {
      this.mostrarPainelEdicao = true;
    }
  }

  private salvar(validacao: Validacao) {
    this.atualizarLista = false;
    this.validacaoService.update(validacao).subscribe(
      result => {
        this.atualizarLista = true;
        this.mensagem.open("Registro salvo com sucesso!", "X", {
          duration: 5000
        });
      },
      error => this.erro(error)
    );
  }

  public perguntaEmitida(idPergunta: number) {
    let validacao: Validacao = new Validacao();
    validacao.codigoPergunta = idPergunta;
    validacao.codigoEstudoSocioEconomico = this.estudo.id;
    if (this.idGrupoFamiliarSelecionado && this.posicao_atual == 2) {
      validacao.codigoGrupoFamiliar = this.idGrupoFamiliarSelecionado;
    }
    // aki eu jah procuro pra ver se a pergunta tem alguma validacaoOutCome
    this.validacaoService
      .filtrar(validacao)
      .subscribe((results: Validacao[]) => {
        if (results && results.length > 0) {
          this.abrirDialog(results[0]);
        } else {
          this.abrirDialog(validacao);
        }
      });
  }

  public estudoEmitido(estudoEmitido: Estudo) {
    this.estudo = estudoEmitido;
    this.validacaoInicial();
  }

  public membroExcluidoRecebido(event: number) {
    this.atualizarLista = true;
  }

  public listaAtualizadaRecebido(event: boolean) {
    // como a lista foi atualiza, entao eu nao preciso ficar atualizando lista agora
    this.atualizarLista = false;
  }
  private abrirDialog(validacao: Validacao) {
    let dialogRef = this.dialog.open(ValidacaoDialog, {
      width: "400px",
      height: "300px",
      data: validacao
    });
    let resultado: any;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.salvar(validacao);
      }
    });
  }

  public rowSelecionada(grupoFamiliar: GrupoFamiliar) {
    if ((this.posicao_atual = 2)) {
      this.idGrupoFamiliarSelecionado = grupoFamiliar.id;
    } else {
      this.idGrupoFamiliarSelecionado = null;
    }
  }

  // criei esse método, pq o angular estava com um bug q não permitia esconder os botões de edição, excluir e altarar Status
  // quando atualizar a versão do angular, tentar novamente esconder esses botões
  mostrarMensagemEdicaoNaoPermitida() {
    this.mensagem.open(
      "A validação só pode ser feita em estudos cujo status seja: 'Em Análise' ou 'Corrigido'",
      "X",
      { duration: 5000 }
    );
  }

  dados_pessoais() {
    this.posicao_atual = 1;
    this.controlaClasse();
  }
  grupo_familiar() {
    this.posicao_atual = 2;
    this.controlaClasse();
  }
  conclusao() {
    this.posicao_atual = 3;
    this.controlaClasse();
  }

  controlaClasse() {
    if (this.posicao_atual == 1) {
      this.class_1 = "current";
      this.class_2 = "done";
      this.class_3 = "done";
    } else if (this.posicao_atual == 2) {
      this.class_1 = "done";
      this.class_2 = "current";
      this.class_3 = "done";
    } else if (this.posicao_atual == 3) {
      this.class_1 = "done";
      this.class_2 = "done";
      this.class_3 = "current";
    }
  }

  // mostra erros na tela
  private erro(erro: string) {
    this.mensagem.open(erro, "X", { duration: 5000 });
    this.isLoading = false;
  }

  // finaliza o subscribe
  private finaliza() {
    this.isLoading = false;
  }
}
